<template>

  <loading-data-page-container
    :loading="!isInitialized && !loadingError"
    :loading-error="loadingError"
    :loading-error-message="loadingErrorMessage"
    :hint="loadingErrorHint"
    class="unternehmen-page">

    <v-container v-if="isInitialized && !loadingError" class="pa-0" fluid>

      <v-row :class="{'flex-nowrap': $vuetify.breakpoint.width > 1099}" no-gutters>

        <v-col :class="{'col-12': $vuetify.breakpoint.width <= 1099}">
          <div class="semanticsection-title2 primary--text">Unternehmen</div>
          <unternehmen />
        </v-col>

        <div :class="{'mx-auto': $vuetify.breakpoint.width <= 1099}"
             class="ml-96">
          <makler-contact-box :boxes="[AboutUnternehmenMaklerBox, AboutUnternehmen.downloadsBox]"
                              :sticky="useSticky()" />
        </div>

      </v-row>

    </v-container>

  </loading-data-page-container>

</template>
<script>

import Unternehmen from "@/components/vertriebsunterstuetzung/Unternehmen";
import MaklerContactBox from '@/components/vertriebsunterstuetzung/MaklerContactBox';
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import BrowserDetectionMixin from "@/components/helper/BrowserDetectionMixin";

export default {
  name: "UnternehmenPage",
  components: { LoadingDataPageContainer, Unternehmen, MaklerContactBox },
  mixins: [contentLoadingMixin(["AboutUnternehmen"]), BrowserDetectionMixin],
  computed: {
    AboutUnternehmenMaklerBox() {
      return this.$store.state.staticPagesContent.AboutUnternehmenMaklerBox;
    }
  },
  methods: {
    useSticky() {
      return !this.isEdge() && (this.$vuetify.breakpoint.width > 1099);
    }
  }
};
</script>

<style>
.unternehmen-page .contact-box-container {
  position: relative;
}

.unternehmen-page .ml-96 {
  margin-left: 96px;
}
</style>
